module.exports = __webpack_public_path__ + "img/cbam-1.c4b33880.png";